<mat-form-field *ngIf="!readOnly" class="searchField" appearance="outline">
  <input
    matInput
    autocomplete="off"
    type="text"
    placeholder="Search by name"
    [(ngModel)]="search"
  />
</mat-form-field>
<div
  class="flex flex-col"
  *ngIf="(organisations | keyvalue)?.length > 0; else noOrganisations"
>
  <div
    matRipple
    class="item flex flex-row justify-start items-center"
    *ngFor="
      let row of organisations
        | keyvalue
        | organisationSortPipe
        | organisationFilterPipe : search
    "
    [class.selected]="selectedIds?.includes(row.key)"
    [class.disabled]="disabledIds?.includes(row.key)"
    (click)="
      readOnly || disabledIds?.includes(row.key) ? null : toggle(row.value)
    "
  >
    <div class="avatar">
      <ca-avatar [fullName]="row.value.name" [fontSize]="15"> </ca-avatar>
    </div>
    <div class="organisation-name">
      <h3>{{ row.value.name }}</h3>
    </div>
  </div>
</div>
<ng-template #noOrganisations>
  <p>
    {{ "organisations.select.empty" | translate }}
  </p>
</ng-template>
